import angular from 'angular'
import abnormalTaskTracking from './abnormalTaskTracking'
import statisticsReport from './statisticsReport'

export default angular.module('declaration.declareASummary', [abnormalTaskTracking, statisticsReport]).config([
    '$stateProvider',
    ($stateProvider) => {
        $stateProvider.state('declaration.declareASummary', {
            abstract: true,
            url: '/declareASummary',
            template: '<div ui-view></div>',
            title: '申报汇总',
        })
    },
]).name



// WEBPACK FOOTER //
// ./src/app/declaration/declareASummary/index.js